// extracted by mini-css-extract-plugin
export default {"mainContainer":"sidenav_mainContainer__tBHDX","container":"sidenav_container__NS7r0","logo":"sidenav_logo__0+QHh","btns":"sidenav_btns__MHxh4"};